import { render, staticRenderFns } from "./PeriodMembers.vue?vue&type=template&id=900b0600&"
import script from "./PeriodMembers.vue?vue&type=script&lang=ts&"
export * from "./PeriodMembers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports